import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        questionCategory: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.form)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, QuestionCategoryResource) {
        this.ModalService = ModalService;
        this.QuestionCategoryResource = QuestionCategoryResource;
    }

    manageLanguages (form) {
        const { questionCategory } = this;
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-forms-questioncategories-translation
                    update="vm.update()"
                    update-form="vm.form"
                    question-category="vm.questionCategory"
                    cancel="vm.$uibModalInstance.dismiss()"
                    class="wrapper"></modals-forms-questioncategories-translation>
                `,
            size: 'xlarge',
            controller ($uibModalInstance, QuestionCategoryResource) {
                this.$uibModalInstance = $uibModalInstance;
                this.questionCategory = questionCategory;
                this.QuestionCategoryResource = QuestionCategoryResource;
                this.form = form;

                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/questioncategories/translation/index.js